import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION27: PdfComponent = {
  type: 'section',
  id: 's27',
  title: '27. Variation',
  content: [
    {
      type: 'altText',
      id: 's27bullets',
      content: [
        'No variation of this Agreement shall be valid or effective unless it is in writing, refers to this Agreement, and is duly signed or executed by or on behalf of each party.',
      ],
      boldFirst: false,
    },
  ],
};
